import { globalEntitlements } from './globalEntitlements';

// Bundle service codes
const BASIC = 's_corp_basic_bundle_v1';
const ESSENTIAL = 's_corp_essential_bundle_v1';
const PREMIUM = 's_corp_premium_bundle_v1';
const ALL_BUNDLES = [BASIC, ESSENTIAL, PREMIUM];

// Plan eligibility: pro, premium, or starter + standalone Worry-Free Service
const PLAN_ELIGIBILITY = [
  ['pro_plan'],
  ['premium_plan'],
  ['starter_plan', 'worry_free_service']
];

// Services that block all bundles
const S_CORP_DESIGNATION = ['s_corp_designator'];

// Services that block each bundle tier specifically
const PACKAGE_BLOCKING_SERVICES = {
  [BASIC]: ['worry_free_service_advanced_addon'],
  [ESSENTIAL]: ['worry_free_service_advanced_addon', 'zb_quarterly_tax_planning'],
  [PREMIUM]: ['worry_free_service_advanced_addon', 'zb_tax_full_service_biz_s_corp', 'zb_tax_full_service_biz_per_llc', 'zb_quarterly_tax_planning', 'money_pro']
};

/**
 * Gets the appropriate S Corp Bundle buy button configuration using globalEntitlements builder
 * @param {...any} args
 * @returns {object} - Buy button configuration object
 */
export const getSCorpBundleBuyButtonConfig = (...args) => {
  const [, serviceCode] = args;
  const serviceToButtonText = {
    [BASIC]: 'productPage.sCorpBundle.buyBox.buttonLabel1',
    [ESSENTIAL]: 'productPage.sCorpBundle.buyBox.buttonLabel2',
    [PREMIUM]: 'productPage.sCorpBundle.buyBox.buttonLabel3'
  };

  const ctaText = serviceToButtonText[serviceCode] || serviceToButtonText[BASIC];

  const builder = globalEntitlements({ ctaText })
    .blockedByRelatedServices(S_CORP_DESIGNATION, 'productPage.sCorpBundle.buyBox.buttonDisabled.tooltip.alreadyHasDesignation')
    .blockedByRelatedServices(ALL_BUNDLES, 'productPage.sCorpBundle.buyBox.buttonDisabled.tooltip.alreadyOwned')
    .requiresAnyOf(PLAN_ELIGIBILITY, 'productPage.sCorpBundle.buyBox.buttonDisabled.tooltip.missingPlan')
    .blockedByRelatedServices(PACKAGE_BLOCKING_SERVICES[serviceCode] || [], 'productPage.sCorpBundle.buyBox.buttonDisabled.tooltip.hasConflictingService');

  return builder.build()(...args);
};
